import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/img/logo_delivery.jpg';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  class: "mask bg-key-color opacity-6"
}, null, -1);
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = {
  class: "sidenav-header"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  id: "iconSidenav",
  class: "top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none",
  "aria-hidden": "true"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "100%",
    "object-fit": "contain"
  }
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-0 horizontal dark"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_sidenav_list = _resolveComponent("sidenav-list");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.layout === 'custom' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "position-absolute w-100 min-height-300 top-0",
    style: _normalizeStyle({
      'background-image': 'url(' + $data.image + ')',
      'background-position-y': '50%'
    })
  }, _hoisted_2, 4)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["min-height-300 position-absolute w-100", `${_ctx.darkMode ? 'bg-trasnparent' : 'bg-key-color'}`])
  }, null, 2), [[_vShow, _ctx.layout === 'default']]), _createElementVNode("aside", {
    id: "sidenav-main",
    class: _normalizeClass(["sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-4", ` ${_ctx.sidebarType} ${_ctx.isRTL ? 'fixed-end me-3 rotate-caret' : 'fixed-start ms-3'} ${_ctx.layout === 'landing' ? 'bg-transparent shadow-none' : ''}`])
  }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_router_link, {
    class: "m-0 navbar-brand",
    to: $options.basePath
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }, 8, ["to"])]), _hoisted_6, _createVNode(_component_sidenav_list)], 2)], 64);
}